<div class="image-container">
  <ng-container *ngIf="image$; else simIcon">
    <img class="image" draggable="false" [src]="image$ | async" />
  </ng-container>

  <ng-template #simIcon>
    <sim-icon [icon_url]="iconUrl" class="image-container__widget-icon" sizeType="full-size" color="#F7F8F8" />
  </ng-template>
</div>
